/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import Joi from 'joi'

export const numberValidation = Joi
  .number()
  .min(0)
  .required()

export const validationSchema = Joi.object({
  minimumPrice: numberValidation.messages({
    'number.min': 'Minimum Price must be non-negative',
    'any.required': 'Minimum Price is required'
  }),
  requiredRoyalty: Joi.number()
    .min(0)
    .max(100)
    .required()
    .messages({
      'number.base': 'Required Royalty must be a number',
      'number.min': 'Required Royalty cannot be negative',
      'number.max': 'Required Royalty cannot exceed 100%',
      'any.required': 'Required Royalty is required'
    }),
  numberLicenses: Joi.number()
    .integer()
    .min(1)
    .required()
    .messages({
      'number.base': 'Number of Licenses must be a number',
      'number.integer': 'Number of Licenses must be a whole number',
      'number.min': 'Number of Licenses must be at least 1',
      'any.required': 'Number of Licenses is required'
    }),
  usageLimit: Joi.number()
    .integer()
    .min(1)
    .required()
    .messages({
      'number.base': 'Usage Limit must be a number',
      'number.integer': 'Usage Limit must be a whole number',
      'number.min': 'Usage Limit must be at least 1',
      'any.required': 'Usage Limit is required'
    }),
  usageFee: numberValidation.messages({
    'number.min': 'Usage Fee must be non-negative',
    'any.required': 'Usage Fee is required'
  }),
  licenseTerm: Joi.number()
    .integer()
    .min(1)
    .required()
    .messages({
      'number.base': 'License Term must be a number',
      'number.integer': 'License Term must be a whole number',
      'number.min': 'License Term must be at least 1 day',
      'any.required': 'License Term is required'
    }),
  benchmarkText: Joi.string()
    .allow('')
    .messages({
      'string.base': 'Benchmark must be a text'
    }),
  llmTagIds: Joi.array()
    .items(Joi.alternatives().try(Joi.number(), Joi.string()))
    .required()
    .messages({
      'array.base': 'Models must be an array'
    }),
  llmCompanyTagIds: Joi.array()
    .items(Joi.alternatives().try(Joi.number(), Joi.string()))
    .required()
    .messages({
      'array.base': 'Companies must be an array'
    }),
  llmGeographiesIds: Joi.array()
    .items(Joi.alternatives().try(Joi.number(), Joi.string()))
    .required()
    .messages({
      'array.base': 'Geographies must be an array'
    })
}).options({
  abortEarly: false,
  errors: {
    label: false
  }
})
